import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@core/components/base-component';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';
import { EstimateService } from '@shared/services/estimate.service';

interface Tab {
  id: string;
  name: string;
  route: string[];
}

@Component({
  selector: 'pop-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less']
})
export class TabsComponent extends BaseComponent implements OnInit {
  @Input() public activeTab: string;

  public tabs: Tab[] = [];

  public departmentLabel: string;
  public constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private estimateService: EstimateService,
    private estimateSettingsService: EstimateSettingsService
  ) {
    super();
  }

  public async ngOnInit() {
    this.departmentLabel = await this.estimateSettingsService.getDepartmentLabel();

    this.tabs = [
      {
        id: 'parameters',
        name: 'TOOLBAR.PARAMETERS',
        route: ['properties']
      },
      {
        id: 'structures',
        name: 'TOOLBAR.STRUCTURE',
        route: ['structure']
      },
      {
        id: 'departments',
        name: this.departmentLabel,
        route: ['department']
      },
      {
        id: 'classifications',
        name: 'TOOLBAR.CLASS',
        route: ['class']
      }
    ];

    this.subscribe(
      this.estimateSettingsService.getEstimateConfiguration(false).subscribe(configs => {
        if (configs.activateInternalFees)
          this.tabs.push({
            id: 'internalResources',
            name: 'TOOLBAR.INTERNAL_RESOURCES',
            route: ['internal-resources']
          });
      })
    );
  }
  public async close() {
    const closePromise = this.router.navigate(['.'], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'merge' // remove to replace all query params by provided
    });
    const savePromise = this.estimateService.saveChangesAsync();

    await Promise.all([closePromise, savePromise]);
    this.estimateService.dialogEmitChanges();
  }
}
